<via-help-resources-layout role="main">
    <h1 class="e-page-title">Browser Support</h1>
    <p>
        <strong>IMPORTANT</strong><br />
        <em>For Internet Explorer users:</em><br />
        <span>
            From January 2017, Euromonitor will support only the latest version of Microsoft&reg; Internet Explorer&reg; Explorer
            (currently IE11). For older IE versions, some functionality may no longer work after this date. Euromonitor Customer Support
            asks that before submitting any tech support queries you ensure you are using the latest version of your IE browser.
        </span>
    </p>
    <p>Accessing Via from mobile devices is not currently supported.</p>
    <table class="e-browser-info-table">
        <tr>
            <th>Browser</th>
            <th>Comments</th>
        </tr>
        <tr>
            <td>Microsoft Internet Explorer</td>
            <td>
                From January 2017, Via will support only the latest Microsoft software updates. Apply all Microsoft software updates. The
                following restrictions should be noted: The full Via site is not supported in Internet Explorer on touch-enabled devices for
                Windows.
            </td>
        </tr>
        <tr>
            <td>Mozilla Firefox, latest stable version</td>
            <td>Euromonitor makes every effort to test and support the most recent version of Firefox.</td>
        </tr>
        <tr>
            <td>Google Chrome, latest stable version</td>
            <td>
                Google Chrome applies updates automatically; Euromonitor makes every effort to test and support the most recent version.
            </td>
        </tr>
        <tr>
            <td>Apple Safari on Mac OS X</td>
            <td>Euromonitor makes every effort to test and support the most recent version of Safari for Mac OS.</td>
        </tr>
    </table>
    <p>
        <strong>Recommendations and Requirements for All Browsers:</strong><br />
        <span>For all browsers, you must enable JavaScript, cookies, and TLS 1.0.</span><br />
        <span>Euromonitor recommends a minimum screen resolution of 1366x768 for the best possible user experience.</span>
    </p>
</via-help-resources-layout>
